import { render, staticRenderFns } from "./TagValue.vue?vue&type=template&id=83e4dfa2&scoped=true&"
import script from "./TagValue.vue?vue&type=script&lang=js&"
export * from "./TagValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e4dfa2",
  null
  
)

export default component.exports